import { SolicitudVoleoDetail } from "@/services/voleo-requests.service";
import { AppColors } from "@/styles/colors";
import { Flex, Grid, GridItem, Text } from "@chakra-ui/react";
import React from "react";
import { rowBg, useVoleoRequestRows } from "./voleo-request-rows";

interface Props {
  detail: SolicitudVoleoDetail | null;
  showExecutionInfo: boolean;
}

export const VoleoRequestMainData = ({ detail, showExecutionInfo }: Props) => {
  const { leftRows, rightRows } = useVoleoRequestRows({ detail, showExecutionInfo });

  return (
    <Grid templateColumns="repeat(2, 1fr)" gap={18}>
      <GridItem>
        <Flex
          flexDir="column"
          padding="12px"
          height="100%"
          border={`1px solid ${AppColors.WHITE_BORDER_1}`}
          borderRadius="12px"
        >
          <Text
            className="amd-card-title"
            paddingBottom="10px"
            textTransform="uppercase"
            paddingX="24px"
            fontWeight={700}
          >
            Detalle
          </Text>

          <Grid templateColumns="repeat(2, 1fr)" gridAutoRows="50px">
            {leftRows.map(({ label, value }, i) => (
              <React.Fragment key={`left-${label}`}>
                <GridItem
                  paddingX="24px"
                  paddingY="8px"
                  display="flex"
                  alignItems="center"
                  backgroundColor={rowBg(i)}
                >
                  <Text className="account-title-label">{label}</Text>
                </GridItem>
                <GridItem
                  paddingX="24px"
                  paddingY="8px"
                  display="flex"
                  alignItems="center"
                  backgroundColor={rowBg(i)}
                >
                  {typeof value === "string" || typeof value === "number" ? (
                    <Text className="account-value-label">{value}</Text>
                  ) : (
                    value
                  )}
                </GridItem>
              </React.Fragment>
            ))}
          </Grid>
        </Flex>
      </GridItem>

      <GridItem>
        <Flex
          flexDir="column"
          padding="12px"
          height="100%"
          border={`1px solid ${AppColors.WHITE_BORDER_1}`}
          borderRadius="12px"
        >
          <Text
            className="amd-card-title"
            paddingBottom="10px"
            textTransform="uppercase"
            paddingX="24px"
            fontWeight={700}
            visibility="hidden"
          >
            -
          </Text>

          <Grid templateColumns="repeat(2, 1fr)" gridAutoRows="50px">
            {rightRows.map(({ label, value }, i) => (
              <React.Fragment key={`right-${label}`}>
                <GridItem
                  paddingX="24px"
                  paddingY="8px"
                  display="flex"
                  alignItems="center"
                  backgroundColor={rowBg(i)}
                >
                  <Text className="account-title-label">{label}</Text>
                </GridItem>
                <GridItem
                  paddingX="24px"
                  paddingY="8px"
                  display="flex"
                  alignItems="center"
                  minW={0}
                  backgroundColor={rowBg(i)}
                >
                  {typeof value === "string" || typeof value === "number" ? (
                    <Text className="account-value-label">{value}</Text>
                  ) : (
                    value
                  )}
                </GridItem>
              </React.Fragment>
            ))}
          </Grid>
        </Flex>
      </GridItem>
    </Grid>
  );
};
